import { render, staticRenderFns } from "./Fontawesome.vue?vue&type=template&id=1ffff1b0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffff1b0')) {
      api.createRecord('1ffff1b0', component.options)
    } else {
      api.reload('1ffff1b0', component.options)
    }
    module.hot.accept("./Fontawesome.vue?vue&type=template&id=1ffff1b0&", function () {
      api.rerender('1ffff1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/icons/Fontawesome.vue"
export default component.exports